import { BRAND_LIST, CountryLanguageSwitcher, DistanceUnit } from 'typings'
import * as Typings from '../typings'

const SlovakiaLocale: Typings.LocaleType = {
  IS_EU: true,
  REGION: Typings.RegionGroupNames.OTHER,
  CODE: 'SK',
  LANGUAGE_CODE: 'en',

  LONG_NAME: 'Slovakia',
  SHORT_NAME: 'SK',

  DISPLAY_NAME: 'Slovakia (English)',
  DISPLAY_COUNTRY: 'Slovakia (English)',

  GEO_COORDINATES: {
    INITIAL_LATITUDE: 48.6459618,
    INITIAL_LONGITUDE: 17.0603942,
    INITIAL_ZOOM: 5,
    INITIAL_ZOOM_DETAILS_PAGE: 15,
  },

  AREAS: {
    '1': 'Banská Bystrica',
    '2': 'Bratislava',
    '3': 'Košice',
    '4': 'Nitra',
    '5': 'Prešov',
    '6': 'Trenčín',
    '7': 'Trnava',
    '8': 'Žilina',
  },

  HOME_PAGE_URL: 'https://www.uniqlo.com/eu-sk/en/',

  MAP_MOBILE_URL: 'https://map.uniqlo.com/eu-sk/en/',

  CONTACT_US_URL: 'https://faq-eu.uniqlo.com/',
  TERMS_OF_USE_URL:
    'https://faq-eu.uniqlo.com/pkb_Home_UQ_EU?l=en&c=category_uq_eu_dk_se%3ARenew_UQEU_C7_3',
  PRIVACY_POLICY_URL:
    'https://faq-eu.uniqlo.com/pkb_Home_UQ_EU?l=dk&c=category_uq_eu_dk_se%3ARenew_UQEU_C7_2',

  POSTCODE_FORMAT: /^[0-9]{3} [0-9]{2}$/,

  CLIENT_ID: {
    [BRAND_LIST.UQ]: '',
  },

  DISTANCE_UNIT: DistanceUnit.KM,

  SHOW_COUNTRY_LANGUAGE_MODAL: {
    [BRAND_LIST.UQ]: CountryLanguageSwitcher.HEADER_SWITCHER_MODAL,
    [BRAND_LIST.GU]: CountryLanguageSwitcher.ALL_DISABLED,
    [BRAND_LIST.PL]: CountryLanguageSwitcher.ALL_DISABLED,
  },

  ONE_TRUST_FOOTER: {
    [BRAND_LIST.UQ]: true,
  },
}

export default SlovakiaLocale
